<template>
    <v-layout class="mb-5" align-start justify-left wrap>
      <v-flex class="container-list">
        <v-card>
          <v-card-title>
            <h2 v-if="totalAmount">{{totalAmount | price('INR')}}</h2>
            <v-spacer></v-spacer>
            <span v-if="totalTransactions">
              {{totalTransactions}}
              transactions
            </span>
            <!-- <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>
          <v-data-table
            :loading="isDataLoading"
            :headers="headers"
            :items="transactions"
            :items-per-page="pageSize"
            :search="search"
            dense
            item-key="key"
            single-expand
            :expanded.sync="expanded"
            :server-items-length="totalTransactions"
            :options.sync="tableOptions"
          >
            <template v-slot:item.account="{ item }">
              <div :class="{'just-edited': item.key == lastEditedKey}">{{item.account.account.name}}</div>
            </template>
            <template v-slot:item.at="{ item }">
              <div :class="{'just-edited': item.key == lastEditedKey}">{{item.at | simpleDate}}</div>
            </template>
            <template v-slot:item.amount="{ item }">
              <div :class="{'just-edited': item.key == lastEditedKey}"><span
              v-if="item.currency">{{item.amount | price(item.currency)}}</span><span
              v-else class="error">ERR {{item.amount}}</span></div>
            </template>
            <template v-slot:item.category="{ item }">
              <div  :class="{'just-edited': item.key == lastEditedKey}" @click="editTransaction(item)">{{item.category.category.name}}</div>
            </template>
            <template v-slot:item.tags="{ item }">
              <div  :class="{'just-edited': item.key == lastEditedKey}" @click="editTransaction(item)">{{item.tags | join}}</div>
            </template>
            <template v-slot:item.narration="{ item }">
              <div 
              :class="{'just-edited': item.key == lastEditedKey}" @click="editTransaction(item)">
              <span 
              v-if="item.narration">{{item.narration}}</span><span 
              v-else-if="(!item.category.category.key) && item.org_notes" class="small-note" >{{item.org_notes}}</span>
              <v-tooltip v-if="item.notes" top color="warning">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    plain
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark small color="warning">mdi-message-bulleted</v-icon>
                  </v-btn>
                </template>
                <span>{{item.notes}}</span>
              </v-tooltip>
              </div>

            </template>
            <template v-slot:item.review_status="{ item }">
              <div class="mr-4">
                <span v-if="item.review_status === 'Created'">
                  <v-btn text x-small @click="markReviewed(item)">
                    <v-icon x-small @click="editTransaction(item)">mdi-checkbox-marked-circle-outline</v-icon>
                    Mark Reviewed
                  </v-btn>
                </span>
                <span v-else>
                  <v-chip
                    class="ma-2"
                    x-small
                    :color="item.review_status === 'Booked' ? 'success': (item.review_status === 'TBD' ? 'yellow': 'primary')"
                  >
                    {{item.review_status}}
                  </v-chip>
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <div class="mr-4">
                <v-icon  :class="{'just-edited': item.key == lastEditedKey}" small @click="editTransaction(item)">edit</v-icon>
              </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <transaction-edit-cat-inline
                  class="mb-5 mt-5"
                  v-if="expanded.length"
                  @saved="onTransactionSaved"
                  @canceled="onTransactionCanceled"
                  :transaction="transactionDraft"
                ></transaction-edit-cat-inline>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
</template>
<style lang="scss" scoped>
  .small-note {
    font-size: 10px;
    color: gray;
  }
  .just-edited {
    color: #1e7b00;
  }
</style>

<script>
import { DataState } from "@/state";
import { Transaction } from "@/models/transaction";
import TransactionEditCatInline from "@/components/TransactionEditCatInline";
export default {
  components: {
      TransactionEditCatInline
  },
  props: {
    state: {
      type: Object,
      default: null
    },
    transactions: Array,
    totalTransactions: {
      type: Number,
      default: undefined
    },
    totalAmount: {
      type: Number,
      default: undefined
    },
    pageSize: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      search: "",
      expanded: [],
      headers: [
        { text: "Account", value: "account", width: 200 },
        { text: "At", value: "at", width: 120 },
        { text: "Amount", value: "amount", align: "right" },
        { text: "Category", value: "category" },
        { text: "Tags", value: "tags" },
        { text: "Narration", value: "narration" },
        { text: "Review", value: "review_status" },
        { text: "Actions", value: "action", sortable: false, width: 60 }
      ],
      transactionDraft: Transaction.newEmpty(),
      lastEditedKey: null,
      editItemIndex: -1,
      tableOptions: {},
    }
  },
  computed: {
    isDataLoading () {
      return this.state && this.state.isLoading()
    }
  },
  watch: {
    tableOptions: {
      handler () {
        this.onTableOptionUpdated()
      },
      deep: true
    }
  },
  methods: {
    editTransaction(transaction) {
      if (this.expanded.length){
        this.expanded.pop();
      }
      this.beginEdit(transaction)
      this.transactionDraft = Transaction.createFromJson(transaction)
      this.expanded.push(this.transactionDraft)
    },

    beginEdit (transaction) {
      this.editItemIndex = this.transactions.findIndex((item)=>{
        if (item.key == transaction.key) {
          return true
        }
      })
    },

    endEdit (transaction) {
      this.lastEditedKey = transaction.key
      if (this.editItemIndex > -1) {
        Object.assign(this.transactions[this.editItemIndex],  transaction)
      }

      this.editItemIndex = -1
    },

    markReviewed (transaction) {
      this.beginEdit(transaction)
      this.state.changeToLoading()
      Transaction.createFromJson(transaction).markReviewed().then((response) => {
        this.state.changeToLoaded()
        this.endEdit(response)
        this.$emit('saved', response, false)
      }).catch((error) => {
        this.endEdit(transaction)
        this.state.changeToError(error)
      })
    },

    editNext(transaction) {
      for( let i=0; i<(this.transactions.length-1); i++) {
        if (this.transactions[i].key == transaction.key) {
          this.editTransaction(this.transactions[i + 1])
        }
      }
    },

    resetEdit(transaction) {
      this.editItemIndex = -1
      this.expanded.pop()
      this.transactionDraft = Transaction.newEmpty()
    },

    onEditDone(transaction, gonext, saved) {
      if (saved) {
        this.endEdit(transaction)
      }
      this.resetEdit(transaction)
      if (gonext) {
        this.editNext(transaction)
      }
    },

    onTransactionSaved(transaction, gonext) {
      this.onEditDone(transaction, gonext, true)
      this.$emit('saved', transaction, gonext)
    },

    onTransactionCanceled(transaction, gonext) {
      this.onEditDone(transaction, gonext, false)
      this.$emit('canceled', transaction, gonext)
    },

    onTableOptionUpdated () {
      this.$emit('tableOptionUpdated', this.tableOptions)
    },


  }
}
</script>
